import React from 'react'

import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Header, Segment, Form, CheckboxProps } from 'semantic-ui-react'

import CustomLabel from '../../../components/common/custom-label/CustomLabel'

import { IProject } from '../../../api/Data'

import CollaborateTabContestLinks from './CollaborateTabContestLinks'

const CollaborateTabContestPage = (props: IProps) => {
  // Props
  const { project, handleChange } = props

  const { enableContest } = project

  const handleCheckboxChange = (e: React.MouseEvent<HTMLInputElement, MouseEvent>, data: CheckboxProps) => {
    const { name, checked } = data
    
    handleChange(e, {
      name: String(name),
      checked:  Boolean(checked),
    })
  }

  return (
    <>
      <Header as="h1" style={{ marginBottom: '2rem', fontWeight: 'bold' }}>
        Public Video Gallery
        <Header.Subheader>
          Create a public gallery and get votes on existing video entries
        </Header.Subheader>
        <Header.Subheader>
          Showcase your project's entries and let the crowd decide. Share this unique link so your audience can <strong>vote, like and comment</strong> on the videos already submitted. Turn your project into a competition and spotlight the best clips.
        </Header.Subheader>
      </Header>
      
      <Segment>
        <Form>
          <Form.Field>
            <CustomLabel>
              <CustomLabel.Text text="Enable Gallery" />
              <CustomLabel.Popup popupContent="Allow contributors to like and comment on videos" />
              <CustomLabel.Checkbox
                name="enableContest"
                checked={enableContest}
                onClick={handleCheckboxChange}
              />
            </CustomLabel>
          </Form.Field>
        </Form>
      </Segment>
      
      {enableContest && (
        <div style={{ width: '100%', backgroundColor: '#ffffff', border: '1px solid rgb(243, 244, 245)', borderRadius: '20px', marginTop: '20px', padding: '20px' }}>
          <CollaborateTabContestLinks project={project} />
        </div>
      )}
    </>
  )
}

interface IProps extends RouteComponentProps<any> {
  project: IProject,
  handleChange: (arg: any, data: any) => void
}

export default withRouter(CollaborateTabContestPage)
